import { apiClient } from "./httpClient";
import { HolidayRequestNotificationConfig, LeaveBalanceHistoryMatrix, LeaveLegendColors } from "./types";

const HOLIDAY_REQUEST_NOTIFICATION_EMAILS_URL = `${process.env.REACT_APP_API_URL}/general-configuration/holiday-request-notification-emails`;
const LEAVE_BALANCE_HISTORY_BY_EMPLOYEE_URL = `${process.env.REACT_APP_API_URL}/general-configuration/leave-balance-history/employees`;
const ADMINISTRATIV_USERS_URL = `${process.env.REACT_APP_API_URL}/general-configuration/administrativ-users`;
const LEAVE_LEGEND_COLORS_URL = `${process.env.REACT_APP_API_URL}/general-configuration/leave-legend-colors`;

export const getHolidayRequestNotificationConfig =
  async (): Promise<HolidayRequestNotificationConfig> => {
    const response = await apiClient.get(
      HOLIDAY_REQUEST_NOTIFICATION_EMAILS_URL,
    );
    return response.data as HolidayRequestNotificationConfig;
  };

export const updateHolidayRequestNotificationConfig = async (
  ccEmails: string[],
): Promise<HolidayRequestNotificationConfig> => {
  const response = await apiClient.put(
    HOLIDAY_REQUEST_NOTIFICATION_EMAILS_URL,
    { ccEmails },
  );
  return response.data as HolidayRequestNotificationConfig;
};

export const getLeaveBalanceHistoryByEmployee =
  async (): Promise<LeaveBalanceHistoryMatrix> => {
    const response = await apiClient.get(LEAVE_BALANCE_HISTORY_BY_EMPLOYEE_URL);
    return response.data as LeaveBalanceHistoryMatrix;
  };

export const updateLeaveBalanceHistoryCell = async (
  employeeId: number,
  year: number,
  unusedDays: number,
  employmentPeriodId?: number,
): Promise<LeaveBalanceHistoryMatrix> => {
  const response = await apiClient.put(
    `${LEAVE_BALANCE_HISTORY_BY_EMPLOYEE_URL}/${employeeId}/${year}`,
    { unusedDays },
    { params: employmentPeriodId ? { employmentPeriodId } : undefined },
  );
  return response.data as LeaveBalanceHistoryMatrix;
};

export const updateAdministrativUsers = async (
  userIds: number[],
): Promise<void> => {
  await apiClient.put(ADMINISTRATIV_USERS_URL, { userIds });
};

export const getLeaveLegendColors = async (): Promise<LeaveLegendColors> => {
  const response = await apiClient.get(LEAVE_LEGEND_COLORS_URL);
  return response.data as LeaveLegendColors;
};

export const updateLeaveLegendColors = async (
  colors: Record<string, string>,
): Promise<LeaveLegendColors> => {
  const response = await apiClient.put(LEAVE_LEGEND_COLORS_URL, { colors });
  return response.data as LeaveLegendColors;
};
